import { combineReducers } from 'redux';
import usersReducer from 'core/duck';
import roomReducer from 'features/room-builder/duck';
import trainingReducer from 'features/training/duck';
import irregularitiesReducer from 'features/irregularities/duck';
import tcEventReducer from 'features/tc-event-dashboard/duck';
import tcRenewalReducer from 'features/tc-renewal/duck';
import tcReducer from 'features/tc/duck';
import addressReducer from 'shared/ducks/addressDuck';
import staticReducer from 'shared/ducks/staticDuck';
import locationReducer from 'shared/ducks/locationDuck';
import taskManagementReducer from 'features/task-management/duck';
import staffReducer from 'features/staff-and-rooms/duck';
import sendEmailReducer from 'features/profile/send-email-container/duck';
import eventChecklistReducer from 'features/event-checklist/duck';
import notificationsReducer from 'features/notifications/duck';
import dashboardReducer from 'features/dashboard/duck';
import materialChainReducer from 'features/material-chain/duck';
import seatingChartReducer from 'features/seating-chart/duck';
import rostersReducer from 'features/rosters/duck';
import requestUpdateReducer from 'features/request-update/duck';
import onlineTestingReducer from "../features/online-testing/duck";

const appReducer = combineReducers({
  location: locationReducer,
  users: usersReducer,
  userDashboard: dashboardReducer,
  roomOptions: roomReducer,
  training: trainingReducer,
  address: addressReducer,
  statics: staticReducer,
  irregularities: irregularitiesReducer,
  tcEvent: tcEventReducer,
  tcRenewal: tcRenewalReducer,
  tc: tcReducer,
  taskManagement: taskManagementReducer,
  eventChecklist: eventChecklistReducer,
  staff: staffReducer,
  email: sendEmailReducer,
  notifications: notificationsReducer,
  materialChain: materialChainReducer,
  seatingChart: seatingChartReducer,
  rosters: rostersReducer,
  requestUpdate: requestUpdateReducer,
  onlineTesting: onlineTestingReducer,
});

const rootReducer = (state, action) => {
  // clear all states on user logout
  if (action.type === 'users/LOGOUT_SUCCESS') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
